import React from 'react';
import FloatingLabelInputLayout from './FLInputLayout';
import { NumberInputLayoutType, BaseChangeEvent, CommonInputLayoutProps } from 'framework/form';

const FLNumberInputLayout: NumberInputLayoutType = (props: CommonInputLayoutProps<BaseChangeEvent, number>) => {
  const { value, ...restProps } = props;
  const stringValue = value !== undefined && value !== null ? String(value) : value;

  return <FloatingLabelInputLayout {...restProps} value={stringValue} type="number" />;
};

export default FLNumberInputLayout;
